import React, { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import { enquireScreen } from "enquire-js";
import "./static/style";
import logo from "../assets/imgs/home/home_title.png";
import coinImg from "../assets/imgs/home/home_coin.png";
import downloadImg from "../assets/imgs/home/home_download.png";
// PasaCredito
const Home = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [dowonloadUrl, setDownloadUrl] =useState("");
  
  const desc1 = "En sólo tres pasos, ¡puede obtener un";
  const desc2 = "préstamo en tan sólo 2-24 horas!";
  const desc3 = "Registro -> Evaluación -> Desembolso";
  const privacidad = "< Acuerdo de Privacidad >";
  const servicio = "< Acuerdo de Servicio >";

  const downloadApk = () =>{
    console.log('dowonloadUrl',dowonloadUrl)
    if(!dowonloadUrl){
      return;
    }
    window.location.href = dowonloadUrl
  }

  useEffect(() => {
    enquireScreen((b) => {
      setIsMobile(b);
      if(isMobile){
        
      }
    });

    fetch( window.location.origin + '/contenido',{
      method:'GET',
      headers:{'Content-Type':'application/json;charset=UTF-8'},
      mode:'no-cors',
      cache:'default'
    })
    .then(res =>res.json())
    .then((res) => {
      if(res.ret === 0) {
        const { data={} } = res;
        setDownloadUrl(data.url)
      }
    }) 
  }, []);


  const serviceInfo = () => {
    return (
      <div className="services-container">
        <div className="contact">
          <span>Contáctanos：</span>
          <span>service@pasacredito.com</span>
        </div>
        <div className="regulations">
          <span>Regulations：</span>
          <div className="ps-selections">
            <a href='/acuerdoPolitica' target="_blank">{privacidad}</a>
            <a href='/acuerdoTerminos' target="_blank">{servicio}</a>
          </div>
        </div>
      </div>
    );
  };

  return [
    <DocumentTitle title="PasaCredito" />,
    <div className="home-page">
      <div className="main-container">
        <img className="main-logo" src={logo} alt="logo" />
        <div className="left-selection">
          <div className="title">
            PRÉSTAMO SIMPLE Y RÁPIDO,
            <br />
            LE AYUDARÁ A RESOLVER EL
            <br />
            PROBLEMA
          </div>
          <div className="desc-selection">
            <span className="desc">
              {desc1}
              <br />
              {desc2}
              <br />
              {desc3}
              <br />
            </span>
          </div>
          {serviceInfo()}
        </div>
        <div className="right-selection">
          <img className="donwload-img" src={coinImg} alt="coinImg" />
          <button className="download-butoon"  onClick={() => downloadApk()}>
            <img src={downloadImg} alt="downloadImg" />
            <span>Descargar PasaCredito</span>
          </button>
        </div>
      </div>
      <div className="footer-container">
      Copyright © 2024 | Pefectivo | All Rights Reserved
    </div>
    </div>,
  ];
};
export default Home;
